import * as React from 'react'
import moment from 'moment'
import { useFormatTime } from '~/hooks/useFormatTime'

export function NextContactCell({ row }) {
  const request = row.original
  const isPastDue = moment(request.next_contact_date).isBefore(moment()) // Check if next_contact_date is in the past
  const formatTime = useFormatTime()

  return (
    <span className={isPastDue ? 'text-red-500' : ''}>
      {formatTime(request.next_contact_date, 'short')}
    </span>
  )
}
